export const DOGS_OF_AMAZON_LINK = 'https://www.amazon.com/dogsofamazon';
